export const isMoreThanSize = ({ file, maxSize, message }) => {
  const maxSizeInMb = maxSize * 1024 * 1024;
  if (file.size > maxSizeInMb) {
    return message;
  }
};

export const acceptedFileFormat = ({ accept, file, message }) => {
  if (!accept.includes(file.type)) {
    return message;
  }
};
